import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let service = {
    getData: () => {
        return axios.get(API + '/exact/data');
    },
    authorize: (data) => {
        return axios.post(API + '/exact/authorize', data);
    },
    hasCredentials: (id) => {
        return axios.post(API + '/exact/has_credentials', {project_id: id});
    },
    clearCredentials: (id) => {
        return axios.post(API + '/exact/clear_credentials', {project_id: id});
    }
};

export default service;